const e = {
  containerWidths: {
    medium: "966px"
  },
  colors: {
    "sand-5": "#f6f6f3"
  },
  mediaQueries: {
    "bl-handset-down": "@media screen and (max-width: 567px)",
    "bl-handset-large-up": "@media screen and (min-width: 568px)",
    "bl-tablet-large-up": "@media screen and (min-width: 1024px)"
  }
};
export {
  e as default
};
//# sourceMappingURL=index.es62.js.map
